<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>
    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Modificación de teléfono</b-card-header>
      <b-card-body>
        <div class="text-center">
          <img src="@/assets/tel_ok_gris.png" class="img-fluid" />
        </div>
        <div>
          <b-card-text class="margin-top text-center" style="color:#9c9c9c;">
            <label>{{this.message}}</label>
          </b-card-text>
          <div class="row form-group justify-content-center">
            <div class="col-2">
              <Label class="h3 mt-1">Prefijo</Label>
              <base-input v-model="model.prefix" onlyNumbers :maxLength="5" placeholder="Ej.:11"></base-input>
            </div>
            <div class="col-4">
              <Label class="h3 mt-1">Número</Label>
              <base-input
                v-model="model.telephone"
                onlyNumbers
                :maxLength="8"
                placeholder="Ej.:43239121"
              ></base-input>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-12 text-center">
              <b-button
                variant="danger"
                style="background-color:transparent; color:#ff5855;"
                @click="btnAceptarClick"
              >Aceptar</b-button>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style scoped>
.btn-danger {
  border-color: #ff5855;
  background-color: #ff5855;
}
.resend {
  border-color: #ff5855;
  background-color: #fff;
  color: #ff5855;
}

.h3.mt-1 {
  color: #ff5855;
}
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import PincodeInput from "vue-pincode-input";
import PinValidation from "@/views/Pin/PinValidation";

export default {
  components: {
    "pincode-input": PincodeInput,
    "pin-validation": PinValidation
  },
  props: {
    url: {
      type: String,
      default: "/dashboard",
      description: "Url para realizar push luego de validar"
    },
    message: {
      type: String,
      default: "Modificá el número de teléfono",
      description: "Mensaje a mostrar en la pantalla de validacion"
    },
    accountID: {
      type: Number,
      default: 0,
      description: "Id de cuenta del telefono"
    }
  },
  data() {
    return {
      model: {
        prefix: "",
        telephone: "",
        showPinValidation: false,
        showMsgResult: false,
        numberComplete: 0
      }
    };
  },

  methods: {
    GetAccountTelephone() {
      let context = this;
      let param = { AccountID: context.accountID };
      axiosHelpers.axiosPost(
        "Account/GetAccountTelephoneForValidation",
        param,
        this,
        data => {
          context.model.prefix = data.ResponseVM.Prefix;
          context.model.telephone = data.ResponseVM.Telephone;
          context.model.numberComplete =
            context.model.prefix + context.model.telephone;
        }
      );
    },
    btnAceptarClick() {
      let context = this;

      axiosHelpers.axiosPost(
        "Account/SaveAccountTelephone",
        {
          AccountID: context.accountID,
          Prefix: context.model.prefix,
          CellPhone: context.model.telephone
        },
        context,
        function(data) {
          if (data.ResponseVM.Success) {
            notificationHelpers.showSuccess(
              "Modificación de Telefono",
              "Se ha modificado el Telefono correctamente",
              context
            );
            context.$router.push({
              name: context.url.replace(/\//g, ''),
              params: { EntityIDProp: context.accountID }
            });
          }
        }
      );
    }
  },
  beforeMount() {
    this.GetAccountTelephone();
  }
};
</script>